import { render, staticRenderFns } from "./OperaOrgsWindow.vue?vue&type=template&id=68d2c6cc&scoped=true&"
import script from "./OperaOrgsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaOrgsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaOrgsWindow.vue?vue&type=style&index=0&id=68d2c6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d2c6cc",
  null
  
)

export default component.exports